import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class PolicyServicingAppSettings {
    //Provide all the Application Configs here

    public  _viewModuleName = "Product Configurator"
    public _allowedRoles = ["ADMIN", "CSR"]
    
    constructor() {
    }
}
 